import styled from 'styled-components';

import { COLORS } from '~/src/common/theme';

import ButtonBase from './BaseButton';

const TransparentButton = styled(ButtonBase)`
  &:disabled {
    color: ${COLORS.NEUTRAL_DISABLED};
  }

  &:not(:disabled) {
    color: ${COLORS.ACTION_DEFAULT};

    &:hover,
    &:hover span {
      color: ${COLORS.ACTION_HOVER};
    }
  }
`;

export default TransparentButton;
